const counselors = {
  noResults: "Keine Bearbeiter:innen vorhanden.",
  backAria: "Zurück zur Übersicht",
  roles: {
    supervisor: "Supervisor",
    counselor: "Bearbeiter:in",
  },
  table: {
    counselor: "Bearbeiter:in",
    kzz: "KZZ",
    team: "Team",
    phoneExtension: "Durchwahl",
    email: "E-Mail",
    weeklyHours: "Std./Wo.",
  },
  tabs: {
    personalData: "Persönliche Daten",
    workTime: "Arbeitszeit",
    dutyPreferences: "Präferenzen für Dienstplan",
  },
  presence: {
    present: "Anwesend",
    absent: "Abwesend",
  },
  fields: {
    userId: "User ID",
    mandantId: "Mandant ID",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    kzz: "KZZ",
    roles: "Rollen/Rechte",
    team: "Team",
    teamLeader: "Teamleiter",
    mobileNumber: "Mobilnummer",
    phoneExtension: "Durchwahl",
  },
  personalData: {
    portalCard: "Daten aus dem FSW Portal",
    ownCard: "Persönliche Daten",
    saveSuccess: "Persönliche Daten wurden gespeichert.",
    saveFailed: "Persönliche Daten konnten nicht gespeichert werden.",
    validation: {
      invalidUserCode: "Das Kürzel darf nur Buchstaben und Ziffern enthalten (keine Umlaute).",
      // The Kürzel is shared between counselors and volunteers; the backend rejects one already in use.
      userCodeTaken: "Dieses Kürzel ist bereits vergeben.",
    },
  },
  workTime: {
    contractualHours: {
      title: "Vertragliche Arbeitszeit",
      weeklyHours: "Vertraglich vereinbart",
      weeklyHoursUnit: "h / Woche",
    },
    allocation: {
      title: "Aufteilung der Arbeitszeit",
      total: "Gesamt",
      workArea: "Tätigkeit",
      team: "Team",
      validFrom: "Von",
      validTo: "Bis",
      hoursPerWeek: "Std./Wo.",
      addButton: "Tätigkeit hinzufügen",
      deleteRow: "Eintrag entfernen",
    },
    saveSuccess: "Arbeitszeit wurde gespeichert.",
    validation: {
      overlappingPeriod: "Die Gültigkeitszeiträume derselben Tätigkeit dürfen sich nicht überschneiden.",
      invalidDateRange: "Das Enddatum darf nicht vor dem Startdatum liegen.",
      multipleOpen: "Pro Tätigkeit darf nur ein Eintrag ein offenes Enddatum haben.",
    },
  },
  dutyPreferences: {
    courts: {
      title: "Gerichte",
      preferred: "Wunschgerichte",
      excluded: "Ausgeschlossene Gerichte",
      excludedHint: "Gerichte, an denen diese Person nicht eingesetzt wird.",
      none: "Keine",
      courtInBothLists: "Ein Gericht kann nicht gleichzeitig Wunschgericht und ausgeschlossenes Gericht sein.",
    },
    duties: {
      title: "Dienste",
      weekday: "Werktag",
      courtHours: "Stundenausmaß für Gerichte (BG)",
      awHours: "Stundenausmaß für AW",
      hoursUnit: "h",
      weekdays: {
        monday: "Mo",
        tuesday: "Di",
        wednesday: "Mi",
        thursday: "Do",
        friday: "Fr",
      },
    },
    dutyTypes: {
      aw12: "AW1/2",
      aw3: "AW3",
      bg: "BG",
    },
    blockedPeriods: {
      title: "Sperrzeiträume",
      hint: "In diesen Zeiträumen wird die Person für den gewählten Diensttyp nicht eingeteilt.",
      dutyType: "Diensttyp",
      from: "Von",
      to: "Bis",
      addButton: "Sperrzeitraum hinzufügen",
      deleteRow: "Sperrzeitraum entfernen",
    },
    saveSuccess: "Präferenzen für Dienstplan wurden gespeichert.",
    validation: {
      invalidDateRange: "Das Bis-Datum darf nicht vor dem Von-Datum liegen.",
      overlappingBlockedPeriod: "Sperrzeiträume desselben Diensttyps dürfen sich nicht überschneiden.",
    },
  },
};

export default counselors;
